export class FolderSharingBreadcrum {
    ACCESS_TYPE: string
    FOLDER_ID: number
    NAME: string
    SEQUENCE_NO: number
}
